export default {"src":"/_next/static/media/message.48e73c31.svg","height":512,"width":513};